import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderTaskPostService } from 'src/app/xena-api';
import { PipesModule } from '../pipes/pipes.module';
import { CostPostListComponent } from './cost-post-list/cost-post-list.component';



@NgModule({
  declarations: [CostPostListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    PipesModule
  ],
  providers: [
    OrderTaskPostService
  ],
  exports: [CostPostListComponent]
})
export class CostPostListModule {
  customElementComponent: Type<any> = CostPostListComponent;
}
